"use client"

import { useEffect } from "react"
import axios from "axios"
import { Switch, Route } from "react-router-dom"

import NotFound from "./Pages/NotFound"
import ToastWrapper from "./Components/ToastWrapper"
import AlertMsg from "./ui/AlertMsg"
import { ToastContainer } from "react-toastify"
import useAuthStore from "./store/authStore"

import LitigationRoutes from "./Litigation/Routes.js"
import getBaseUrl from "./apis/getBaseUrl"

import { QueryClient, QueryClientProvider } from "react-query"
import { ReactQueryDevtools } from "react-query/devtools"
import { Redirect } from "react-router-dom/cjs/react-router-dom.min.js"

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
})

function App() {
  const userToken = useAuthStore((state) => state.token)
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated)
  useEffect(() => {
    const hostDetails = getBaseUrl()
    axios.defaults.baseURL = hostDetails.baseUrl

    document.title = "KS Legal - Litigation Panel"

    axios.defaults.params = {}
    if (isAuthenticated) {
      axios.defaults.headers.common["Authorization"] = `Token ${userToken}`
    } else {
      delete axios.defaults.headers.common["Authorization"]
    }
  }, [isAuthenticated, userToken])

  return (
    <div className="App">
      <AlertMsg />
      <ToastWrapper />
      <ToastContainer />

      <QueryClientProvider client={queryClient}>
        <Switch>
          <Route exact path="/404" component={NotFound} />
          <Route path="/admin" component={LitigationRoutes} />
          <Redirect from="/" to="/admin/litigation/batch" />
        </Switch>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </div>
  )
}

export default App
